import { withAuthorization } from "../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { DefaultPage } from "../../../structure/Page/DefaultPage/DefaultPage";
import { lazy } from "react";

const CustomersSettingsPageContent = lazy(() => import("./CustomersSettingsPageContent"));

function CustomersSettingsPageInternal() {
    return (
        <DefaultPage>
            <CustomersSettingsPageContent />
        </DefaultPage>
    );
}

export const CustomersSettingsPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN, Role.PLANNER))(
    CustomersSettingsPageInternal
);
